/**
 * @generated SignedSource<<8567ed14ca99a58f663053749db6f7db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attachmentCategoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastModifiedTimestampUtc"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "size"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "attachmentCategoryId",
            "variableName": "attachmentCategoryId"
          },
          {
            "kind": "Variable",
            "name": "fileName",
            "variableName": "fileName"
          },
          {
            "kind": "Variable",
            "name": "lastModifiedTimestampUtc",
            "variableName": "lastModifiedTimestampUtc"
          },
          {
            "kind": "Variable",
            "name": "parentId",
            "variableName": "parentId"
          },
          {
            "kind": "Variable",
            "name": "size",
            "variableName": "size"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AttachmentCreatePayload",
    "kind": "LinkedField",
    "name": "createAttachment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "attachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewAttachmentModalMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewAttachmentModalMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "ee6ac398f22b068ca30e9e4f6838f6d6",
    "id": null,
    "metadata": {},
    "name": "NewAttachmentModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewAttachmentModalMutation(\n  $parentId: ID!\n  $fileName: String!\n  $size: Long!\n  $lastModifiedTimestampUtc: DateTime!\n  $attachmentCategoryId: ID!\n) {\n  createAttachment(input: {parentId: $parentId, attachmentCategoryId: $attachmentCategoryId, fileName: $fileName, size: $size, lastModifiedTimestampUtc: $lastModifiedTimestampUtc}) {\n    attachment {\n      id\n    }\n    uploadUrl\n  }\n}\n"
  }
};
})();

node.hash = "e4b3a185e1e3c574f0285f4e8eb60bb6";

export default node;
